export { PopupService, POPUP_CONTAINER } from './popup.service';
export { PopupComponent } from './popup.component';
export { PopupModule } from './popup.module';



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-popup/dist/es/main.js
// module id = ../../../../@progress/kendo-angular-popup/dist/es/main.js
// module chunks = 3